// Per-user preference for how the row detail panel is presented (⑤): "dock" = the
// docked side panel (board) / overlay float (Home, Postfach); "large" = a centered
// modal. Stored per browser (≈ per user), shared across all boards + views, and applied
// wherever the DESKTOP panel opens. Mobile ignores it (the full-screen sheet is unchanged).
export type DetailViewMode = "dock" | "large";

const KEY = "flow.detail.view";

export function loadDetailViewMode(): DetailViewMode {
  try {
    return localStorage.getItem(KEY) === "large" ? "large" : "dock";
  } catch {
    return "dock";
  }
}

export function saveDetailViewMode(mode: DetailViewMode): void {
  try {
    localStorage.setItem(KEY, mode);
  } catch {
    /* ignore quota/availability errors — the preference just won't persist */
  }
}
